import api from "!../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../ckEditorCustom/node_modules/css-loader/dist/cjs.js!../../../../../../ckEditorCustom/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./blocktoolbar.css";

var options = {"injectType":"singletonStyleTag","attributes":{"data-cke":true}};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



export default content.locals || {};